var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgTiktok = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.5,
    d: "M10.794 0h-2.36v9.536c0 1.136-.907 2.07-2.036 2.07-1.13 0-2.037-.934-2.037-2.07a2.07 2.07 0 0 1 1.977-2.07V5.073c-2.4.041-4.336 2.01-4.336 4.464C2.002 12.012 3.978 14 6.418 14c2.44 0 4.417-2.009 4.417-4.464v-4.89a5.463 5.463 0 0 0 3.125 1.055V3.307c-1.774-.06-3.166-1.521-3.166-3.307Z"
  })));
});
SvgTiktok.displayName = "SvgTiktok";
export default SvgTiktok;